import {
  Box,
  Typography,
  Button,
  Grid,
  FormControlLabel,
  Checkbox,
  Card,
  CardContent,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import BotBg from "assets/Icons/bot_bg_1.svg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { startBotAgent } from "utils/lambda";
import AgentBotServices from "services/bot";
import BotCheck from "assets/Icons/bot_check.svg";
import BotUnCheck from "assets/Icons/bot_uncheck.svg";
import BotProgress from "components/progressbar";
import BotStart from "assets/Icons/bot_start.svg";
import CommonTable from "components/commontable";
import BotLoader from "components/agent_bot/botLoader";
import BotGalaxy from "assets/Icons/bot_galaxy.svg";
import NovaIcon from "assets/Icons/nova_icon.svg";
import OrionIcon from "assets/Icons/orion_icon.svg";
import LyraIcon from "assets/Icons/lyra_icon.svg";
import VegaIcon from "assets/Icons/vega_icon.svg";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import { io } from "socket.io-client";

const socket = io(process.env.REACT_APP_BASE_URL, {
  transports: ["websocket"],
  reconnection: true,
  reconnectionDelay: 2000,
  reconnectionAttempts: 10,
});

const AiAgent = () => {
  const [started, setStarted] = useState("idle"); // idle | running | success | failed
  const [status, setStatus] = useState({
    job_id: null,
    bot_number: 1, // assume starting from bot 1
    status: "pending", // default status
    vin: null,
    container_no: null,
    vendor: null,
    invoice_no: null,
    uniquevin: null,
    uniquevendor: null,
    uniquecontainer: null,
    totalCount: 0,
    completedCount: 0,
    failedCount: 0,
    inProgressCount: 0,
    partialCount: 0,
    pendingCount: 0,
    percent: 0,
    message: "Preparing Vendor Costing Data...",
  });
  const [selectedType, setSelectedType] = useState("");
  const [botsSummary, setBotsSummary] = useState({
    bot1: {},
    bot2: {},
    bot4: {},
    bot5: {},
  });

  const [stats, setStats] = useState({});
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  });
  const [loading, setLoading] = useState(false);
  const [jobId, setJobId] = useState(null);
  const [muted, setMuted] = useState(
    localStorage.getItem("bot_voice_muted") === "true"
  );

  const toggleMute = () => {
    const newState = !muted;
    setMuted(newState);

    // Stop any current speech immediately
    if (newState && window.speechSynthesis) {
      window.speechSynthesis.cancel();
    }

    localStorage.setItem("bot_voice_muted", newState);
  };

  const columns = [
    { label: "Run Date", field: "updatedAt", type: "date" },
    { label: "Container No", field: "container_no" },
    { label: "VIN #", field: "vin" },
    { label: "Invoice#", field: "invoice_no" },
  ];
  const handleCheckboxChange = (type) => {
    // 🔗 If user clicks shipping or towing
    if (type === "shipping" || type === "towing") {
      // If already linked as shipping_towing and user clicks again → uncheck
      if (selectedType === "shipping_towing" || type === selectedType) {
        setSelectedType("");
      } else {
        // Link them together
        setSelectedType("shipping_towing");
      }
      return;
    }

    // 🔹 Handle normal single-type toggles (like clearance)
    if (selectedType === type) {
      // Clicking again unselects it
      setSelectedType("");
    } else {
      setSelectedType(type);
    }
  };

  const getStatus = async () => {
    try {
      const params = { table: selectedType };
      const response = await AgentBotServices.getAgentStatus(params);

      if (response?.data?.result?.success) {
        const result = response.data.result;
        const latestRecord = result.latestRecord || {};
        const uniqueRecord = result.uniqueCounts || {};

        // Save everything you need for progress bars
        setStatus({
          job_id: result.job_id,
          bot_number: Number(result.bot_number || 0),
          status: result.status,
          vin: result.vin || null,
          container_no: result.container_no || null,
          vendor: latestRecord.vendor_name || result?.vendor_name || null,
          invoice_no: latestRecord.invoice_no || result?.invoice_no || null,
          uniquevin: uniqueRecord?.vin || 0,
          uniquevendor: uniqueRecord?.vendor_name || 0,
          uniquecontainer: uniqueRecord?.container_no || 0,
          totalCount: result.total || 0,
          completedCount: result.completed || 0,
          failedCount: result.failed || 0,
          inProgressCount: result.in_progress || 0,
          partialCount: result.partialCount || 0,
          pendingCount: result.pendingCount || 0,
          percent: result.percent || 0,
          message: result.message || "",
        });
      }
    } catch (err) {
      console.error("❌ Polling failed:", err);
    }
  };

  // useEffect(() => {
  //   const handleConnect = () => {
  //     console.log("✅ Socket connected:", socket.id);
  //     if (selectedType) {
  //       console.log("🟢 Emitting get_status for:", selectedType);
  //       socket.emit("get_status", selectedType);
  //     }
  //   };

  //   const handleDisconnect = (reason) => {
  //     console.warn("⚠️ Socket disconnected:", reason);
  //   };

  //   const handleConnectError = (err) => {
  //     console.error("❌ Socket connect_error:", err.message);
  //   };

  //   socket.on("connect", handleConnect);
  //   socket.on("disconnect", handleDisconnect);
  //   socket.on("connect_error", handleConnectError);

  //   return () => {
  //     socket.off("connect", handleConnect);
  //     socket.off("disconnect", handleDisconnect);
  //     socket.off("connect_error", handleConnectError);
  //   };
  // }, [selectedType]);

  // useEffect(() => {
  //   if (!selectedType) return;

  //   const interval = setInterval(() => {
  //     socket.emit("get_status", selectedType);
  //   }, 10000);

  //   return () => clearInterval(interval);
  // }, [selectedType]);

  // useEffect(() => {
  //   const handleStatus = (data) => {
  //     if (!data || data.table !== selectedType) return;

  //     const result = data.result;
  //     if (result?.success) {
  //       const latestRecord = result.latestRecord || {};
  //       const uniqueRecord = result.uniqueCounts || {};

  //       setStatus({
  //         job_id: result.job_id,
  //         bot_number: Number(result.bot_number || 0),
  //         status: result.status,
  //         vin: result.vin || null,
  //         container_no: result.container_no || null,
  //         vendor: latestRecord.vendor_name || result?.vendor_name || null,
  //         invoice_no: latestRecord.invoice_no || result?.invoice_no || null,
  //         uniquevin: uniqueRecord?.vin || 0,
  //         uniquevendor: uniqueRecord?.vendor_name || 0,
  //         uniquecontainer: uniqueRecord?.container_no || 0,
  //         totalCount: result.total || 0,
  //         completedCount: result.completed || 0,
  //         failedCount: result.failed || 0,
  //         inProgressCount: result.in_progress || 0,
  //         partialCount: result.partialCount || 0,
  //         pendingCount: result.pendingCount || 0,
  //         percent: result.percent || 0,
  //         message: result.message || "",
  //       });
  //     } else if (data.error) {
  //       console.error("❌ Socket bot_status error:", data.message);
  //     }
  //   };

  //   socket.on("bot_status", handleStatus);

  //   // cleanup listener
  //   return () => {
  //     socket.off("bot_status", handleStatus);
  //   };
  // }, [selectedType]);

  const [buttonDisabled, setButtonDisabled] = useState(false);

  useEffect(() => {
    socket.on("progress_status_all", (data) => {
      if (!data?.results) return;

      const { shipping, towing, clearance } = data.results;

      const anyInProgress =
        shipping?.inProgress || towing?.inProgress || clearance?.inProgress;

      setButtonDisabled(anyInProgress);
    });

    return () => {
      socket.off("progress_status_all");
    };
  }, []);

  const getList = async (page = 1, job = null) => {
    setLoading(true);
    try {
      const params = {
        table: selectedType,
        page,
        limit: pagination.limit,
        job_id: job,
      };

      const response = await AgentBotServices.getAgentList(params);
      if (response?.data?.result) {
        const result = response.data.result;

        // ✅ Update table data
        setData(result.data || []);

        // ✅ Fix: use pagination object from backend
        const p = result.pagination || {};
        setPagination({
          page: p.page || page,
          limit: p.limit || pagination.limit,
          total: p.total || 0,
          totalPages: p.totalPages || 1,
        });
      }
    } catch (err) {
      console.error("❌ Fetch failed:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (jobId) {
      setPagination({ page: 1, limit: 10, total: 0, totalPages: 1 });
      getList(1, jobId);
    }
  }, [selectedType, jobId]);

  const handlePageChange = (e, value) => {
    getList(value, jobId);
  };
  const handleStart = async () => {
    try {
      setStatus({
        job_id: null,
        bot_number: 1,
        status: "pending",
        vin: null,
        container_no: null,
        uniquevin: null,
        uniquevendor: null,
        uniquecontainer: null,
        invoice_no: null,
        vendor: null,
        totalCount: 0,
        completedCount: 0,
        failedCount: 0,
        inProgressCount: 0,
        partialCount: 0,
        pendingCount: 0,
        percent: 0,
        message: "Preparing Vendor Costing Data...",
      });
      setStarted("running");

      await new Promise((r) => setTimeout(r, 2000));

      const payload = { table: selectedType };
      const res = await startBotAgent(payload);
      console.log("🚀 Start response:", res);

      let parsed = {};
      try {
        if (typeof res?.body === "string") parsed = JSON.parse(res.body);
        else if (res?.data?.body && typeof res.data.body === "string")
          parsed = JSON.parse(res.data.body);
        else parsed = res?.body || res?.data || {};
      } catch (e) {
        console.error("❌ Parse failed", e);
        parsed = {};
      }

      const bots = parsed?.summary || {};
      const job_id = parsed?.job_id || null;

      // ⏳ Poll status after start
      setTimeout(() => getStatus(), 1000);

      if (res?.statusCode === 200) {
        setStarted("success");
        setJobId(job_id);

        // ✅ Just store EXACT response — NO modification
        setBotsSummary(bots);

        // Refresh grid if any bot did something
        if (
          bots?.bot1?.actionPerformed ||
          bots?.bot2?.actionPerformed ||
          bots?.bot4?.actionPerformed ||
          bots?.bot5?.actionPerformed
        ) {
          getList(1, job_id);
        }
      } else {
        console.error("❌ Failed to start", res);
        setStarted("failed");
      }
    } catch (err) {
      console.error("❌ Error calling Lambda:", err);
      setStarted("failed");
    }
  };

  useEffect(() => {
    let interval;
    if (started === "running") {
      interval = setInterval(() => {
        getStatus();
      }, 10000); // poll every 10s
    }
    return () => clearInterval(interval);
  }, [started]);

  const startagain = () => {
    setStarted("idle");
    setSelectedType("");
    setData([]);
    setBotsSummary({
      bot1: { actionPerformed: false, duration: "0 min 0 sec" },
      bot2: {
        actionPerformed: false,
        duration: "0 min 0 sec",
        vinCount: 0,
        containerCount: 0,
        vendorCount: 0,
      },
      bot4: {
        actionPerformed: false,
        duration: "0 min 0 sec",
        totalProcessed: 0,
        totalSuccess: 0,
        totalFailed: 0,
      },
      bot5: {
        actionPerformed: false,
        duration: "0 min 0 sec",
        totalProcessed: 0,
        totalSuccess: 0,
        totalFailed: 0,
      },
    });
    setStatus({
      job_id: null,
      bot_number: 1, // assume starting from bot 1
      status: "pending", // default status
      vin: null,
      container_no: null,
      vendor: null,
      totalCount: 0,
      completedCount: 0,
      failedCount: 0,
      inProgressCount: 0,
      partialCount: 0,
      pendingCount: 0,
      percent: 0,
      message: "Preparing Vendor Costing Data...",
    });
    setPagination({ page: 1, limit: 10, total: 0, totalPages: 1 });
    setJobId(null);
  };

  return (
    <>
      {started === "idle" ? (
        <>
          <Box
            sx={{
              width: "100%",
              minHeight: "100vh",
              backgroundImage: `url(${BotBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              color: "white",
            }}
          >
            {/* <MainBot/> */}
            {/* Bot Image */}

            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", mb: 1, fontSize: "44px" }}
            >
              Hi! I Am <span style={{ color: "#56B711" }}>NOVA</span>
            </Typography>

            <Typography
              sx={{
                fontFamily: "sans-serif",
                color: "#FFFFFF",
                mb: 3,
                fontWeight: "300 !important",
                fontSize: "40px",
              }}
            >
              Your Vendor Costing Assistant
            </Typography>
            <Box
              component="img"
              src={BotStart}
              alt="Bot"
              sx={{ width: "40%", height: "40%" }}
            />

            <Typography
              sx={{
                color: "#FFFFFF",
                fontWeight: 500,
                fontSize: "32px",
              }}
            >
              Please Select The Costing Type You Want Me To Process{" "}
            </Typography>

            {/* ✅ Custom Checkbox Icons (radio-like behavior) */}
            <Box sx={{ display: "flex", gap: 3, mb: 3 }}>
              {["Shipping", "Towing", "Clearance"].map((type) => (
                <FormControlLabel
                  key={type}
                  control={
                    <Checkbox
                      icon={<img src={BotUnCheck} alt="un_check" />}
                      checkedIcon={<img src={BotCheck} alt="checked" />}
                      checked={
                        selectedType === type.toLowerCase() ||
                        (selectedType === "shipping_towing" &&
                          (type.toLowerCase() === "shipping" ||
                            type.toLowerCase() === "towing"))
                      }
                      onChange={() => handleCheckboxChange(type.toLowerCase())}
                    />
                  }
                  label={type}
                />
              ))}
            </Box>

            {/* Start Button */}
            <Button
              onClick={handleStart}
              variant="contained"
              disabled={!selectedType || buttonDisabled} // disable until selection
              sx={{
                background: "linear-gradient(to right, #0C6135, #5BBC0F)",
                px: 4,
                py: 1,
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: "bold",
                "&:hover": {
                  background: "linear-gradient(to right, #0C6135, #5BBC0F)",
                },
              }}
            >
              Start Invoices Processing
            </Button>
          </Box>
        </>
      ) : started === "running" ? (
        <>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              minHeight: "100vh",
              backgroundImage: `url(${BotBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              color: "white",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <img src={BotGalaxy} alt="logo" />
              <Typography sx={{ fontSize: "42px", fontWeight: 400 }}>
                <strong style={{ fontWeight: 600 }}>
                  {status?.bot_number === 1
                    ? "NOVA"
                    : status?.bot_number === 2
                    ? "ORION"
                    : status?.bot_number === 4
                    ? "LYRA"
                    : "VEGA"}
                </strong>{" "}
                -{" "}
                {status?.bot_number === 1
                  ? "Data Specialist"
                  : status?.bot_number === 2
                  ? "Invoices Processor"
                  : status?.bot_number === 4
                  ? "Costing Executor"
                  : "Storage & Late Fee Executer"}
              </Typography>
            </Box>
            <BotLoader botStatus={status} muted={muted} />
            <BotProgress botStatus={status} />
            <div
              onClick={toggleMute}
              style={{
                position: "absolute",
                top: 70,
                right: 20,
                background: "#4ab43e",
                borderRadius: "50%",
                padding: "8px",
                cursor: "pointer",
                zIndex: 10,
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              }}
            >
              {muted ? (
                <VolumeOffIcon style={{ fontSize: 24 }} />
              ) : (
                <VolumeUpIcon style={{ fontSize: 24 }} />
              )}
            </div>
          </Box>
        </>
      ) : (
        <>
          <Box
            sx={{
              width: "100%",
              minHeight: "100vh",
              backgroundImage: `url(${BotBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              color: "white",
              p: 4,
              pt: 12,
            }}
          >
            {/* === Header === */}
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    p: 0,
                    m: 0,
                    textAlign: "start",
                    fontSize: "32px",
                  }}
                >
                  Galaxy Ai - Vendor Costing Assistant
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} textAlign="right">
                <Button
                  onClick={startagain}
                  variant="contained"
                  sx={{
                    background: "linear-gradient(to right, #0C6135, #5BBC0F)",
                    px: 4,
                    py: 1,
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: "bold",
                    "&:hover": {
                      background: "linear-gradient(to right, #0C6135, #5BBC0F)",
                    },
                  }}
                >
                  Start Again
                </Button>
              </Grid>
            </Grid>

            {/* === Summary Cards === */}
            <Grid container spacing={3} sx={{ mt: 2 }}>
              {/* BOT 1 — Data Specialist */}
              <Grid
                item
                xs={12}
                md={selectedType === "shipping_towing" ? 6 : 4}
              >
                <SummaryCard
                  img={<img src={NovaIcon} alt="nova" />}
                  title="Data Specialist"
                  color="#4CAF50"
                  desc={`${botsSummary.bot1.duration}`}
                  performed={
                    botsSummary.bot1.actionPerformed ||
                    botsSummary.bot2.actionPerformed ||
                    botsSummary.bot4.actionPerformed ||
                    botsSummary.bot5.actionPerformed
                  }
                  points={() => {
                    const safe = (v) => v || 0;
                    const sum = (...v) => v.reduce((a, b) => a + safe(b), 0);

                    const clr = botsSummary?.bot1?.clearance_stats || {};
                    const ship = botsSummary?.bot1?.shipping_stats || {};
                    const tow = botsSummary?.bot1?.towing_stats || {};

                    const isClr = selectedType === "clearance";

                    // ✅ totals
                    const totalPrev = isClr
                      ? safe(clr.previous_success) + safe(clr.previous_failed)
                      : sum(
                          ship?.previous_success,
                          ship?.previous_failed,
                          tow?.previous_success,
                          tow?.previous_failed
                        );

                    const totalNew = isClr
                      ? safe(clr.new_success) + safe(clr.new_failed)
                      : sum(
                          ship?.new_success,
                          ship?.new_failed,
                          tow?.new_success,
                          tow?.new_failed
                        );

                    const totalProcessed = totalPrev + totalNew;

                    // ✅ success
                    const prevSuccess = isClr
                      ? safe(clr.previous_success)
                      : sum(ship?.previous_success, tow?.previous_success);

                    const newSuccess = isClr
                      ? safe(clr.new_success)
                      : sum(ship?.new_success, tow?.new_success);

                    const totalSuccess = prevSuccess + newSuccess;

                    // ✅ failed
                    const prevFailed = isClr
                      ? safe(clr.previous_failed)
                      : sum(ship?.previous_failed, tow?.previous_failed);

                    const newFailed = isClr
                      ? safe(clr.new_failed)
                      : sum(ship?.new_failed, tow?.new_failed);

                    const totalFailed = prevFailed + newFailed;

                    // towing / shipping seperate (only non-clearance)
                    const towLine = `Processed Towing: ${sum(
                      (tow.new_success || 0) + (tow.new_failed || 0),
                      (tow.previous_success || 0) + (tow.previous_failed || 0)
                    )} total — ${sum(
                      tow.previous_success || 0,
                      tow.new_success || 0
                    )} succeeded and ${sum(
                      tow.previous_failed || 0,
                      tow.new_failed || 0
                    )} failed`;

                    const shipLine = `Processed Shipping: ${sum(
                      (ship.new_success || 0) + (ship.new_failed || 0),
                      (ship.previous_success || 0) + (ship.previous_failed || 0)
                    )} total — ${sum(
                      ship.previous_success || 0,
                      ship.new_success || 0
                    )} succeeded and ${sum(
                      ship.previous_failed || 0,
                      ship.new_failed || 0
                    )} failed`;

                    return [
                      "Data sorted by Arrival Port Date",
                      "Client Costings Verification",
                      "Container to VIN Mapping",
                      "Invoice Processing Data Organization",
                      `Previous: ${totalPrev} records — ${prevSuccess} succeeded and ${prevFailed} failed`,
                      `New: ${totalNew} records — ${newSuccess} succeeded and ${newFailed} failed`,
                      ...(selectedType !== "clearance"
                        ? [towLine, shipLine]
                        : []),
                      `Processed ${totalProcessed} records — ${totalSuccess} succeeded and ${totalFailed} failed.`,
                    ];
                  }}
                />
              </Grid>

              {/* BOT 2 — Invoices Processor */}
              <Grid
                item
                xs={12}
                md={selectedType === "shipping_towing" ? 6 : 4}
              >
                <SummaryCard
                  img={<img src={OrionIcon} alt="orion" />}
                  title="Invoices Processor"
                  color="#1D86F6"
                  desc={`${botsSummary.bot2.duration}`}
                  performed={
                    botsSummary.bot2.actionPerformed ||
                    botsSummary.bot4.actionPerformed ||
                    botsSummary.bot5.actionPerformed
                  }
                  points={() => {
                    const safe = (v) => v || 0;
                    const sum = (...vals) =>
                      vals.reduce((a, b) => a + (b || 0), 0);

                    const mod = botsSummary?.bot2?.module_stats || {};
                    const isShip = selectedType === "shipping";
                    const isTowing = selectedType === "towing";
                    const isClr = selectedType === "clearance";
                    const isCombined = selectedType === "shipping_towing";

                    const ship = mod.shipping || {};
                    const tow = mod.towing || {};
                    const clr = mod.clearance || {};

                    let prevTotal = 0,
                      newTotal = 0,
                      prevSuccess = 0,
                      newSuccess = 0,
                      prevFailed = 0,
                      newFailed = 0;

                    if (isClr) {
                      prevTotal = safe(clr?.previous?.total?.vinCount);
                      newTotal = safe(clr?.new?.total?.vinCount);
                      prevSuccess = safe(clr?.previous?.completed?.vinCount);
                      newSuccess = safe(clr?.new?.completed?.vinCount);
                      prevFailed = safe(clr?.previous?.failed?.vinCount);
                      newFailed = safe(clr?.new?.failed?.vinCount);
                    }

                    if (isShip) {
                      prevTotal = sum(
                        safe(ship?.previous?.completed?.vinCount),
                        safe(ship?.previous?.failed?.vinCount)
                      );
                      newTotal = safe(ship?.new?.total?.vinCount);
                      prevSuccess = safe(ship?.previous?.completed?.vinCount);
                      newSuccess = safe(ship?.new?.completed?.vinCount);
                      prevFailed = safe(ship?.previous?.failed?.vinCount);
                      newFailed = safe(ship?.new?.failed?.vinCount);
                    }

                    if (isTowing) {
                      prevTotal = safe(
                        sum(safe(tow?.previous?.completed?.vinCount)),
                        sum(safe(tow?.previous?.failed?.vinCount))
                      );
                      newTotal = safe(tow?.new?.total?.vinCount);
                      prevSuccess = safe(tow?.previous?.completed?.vinCount);
                      newSuccess = safe(tow?.new?.completed?.vinCount);
                      prevFailed = safe(tow?.previous?.failed?.vinCount);
                      newFailed = safe(tow?.new?.failed?.vinCount);
                    }

                    if (isCombined) {
                      prevTotal = sum(
                        safe(ship?.previous?.completed?.vinCount),
                        safe(tow?.previous?.completed?.vinCount),
                        safe(ship?.previous?.failed?.vinCount),
                        safe(tow?.previous?.failed?.vinCount)
                      );
                      newTotal = sum(
                        safe(ship?.new?.total?.vinCount),
                        safe(tow?.new?.total?.vinCount)
                      );

                      prevSuccess = sum(
                        safe(ship?.previous?.completed?.vinCount),
                        safe(tow?.previous?.completed?.vinCount)
                      );
                      newSuccess = sum(
                        safe(ship?.new?.completed?.vinCount),
                        safe(tow?.new?.completed?.vinCount)
                      );

                      prevFailed = sum(
                        safe(ship?.previous?.failed?.vinCount),
                        safe(tow?.previous?.failed?.vinCount)
                      );
                      newFailed = sum(
                        safe(ship?.new?.failed?.vinCount),
                        safe(tow?.new?.failed?.vinCount)
                      );
                    }

                    const total = safe(prevTotal + newTotal);
                    const totalSuccess = safe(prevSuccess + newSuccess);
                    const totalFailed = safe(prevFailed + newFailed);

                    const shippingLine = `Processed Shipping: ${sum(
                      ship?.new?.completed?.vinCount,
                      ship?.previous?.completed?.vinCount,
                      ship?.new?.failed?.vinCount,
                      ship?.previous?.failed?.vinCount
                    )} total — ${sum(
                      ship?.new?.completed?.vinCount,
                      ship?.previous?.completed?.vinCount
                    )} succeeded and ${sum(
                      ship?.new?.failed?.vinCount,
                      ship?.previous?.failed?.vinCount
                    )} failed`;
                    const towingLine = `Processed Towing: ${sum(
                      tow?.new?.completed?.vinCount,
                      tow?.previous?.completed?.vinCount,
                      tow?.new?.failed?.vinCount,
                      tow?.previous?.failed?.vinCount
                    )} total — ${sum(
                      tow?.new?.completed?.vinCount,
                      tow?.previous?.completed?.vinCount
                    )} succeeded and ${sum(
                      tow?.new?.failed?.vinCount,
                      tow?.previous?.failed?.vinCount
                    )} failed`;

                    return [
                      `Reading vendor invoices`,
                      `Previous: ${prevTotal} total — ${prevSuccess} succeeded and ${prevFailed} failed`,
                      `New: ${newTotal} total — ${newSuccess} succeeded and ${newFailed} failed`,
                      ...(isClr ? [] : [towingLine, shippingLine]),
                      ...(isClr
                        ? []
                        : [
                            `Identified ${sum(
                              ship?.new?.completed?.containerCount,
                              ship?.previous?.completed?.containerCount,
                              ship?.new?.failed?.containerCount,
                              ship?.previous?.failed?.containerCount
                            )} unique shipping containers`,
                          ]),
                      ...(isClr
                        ? [
                            `Identified ${sum(
                              clr?.new?.completed?.containerCount,
                              clr?.previous?.completed?.containerCount,
                              clr?.new?.failed?.containerCount,
                              clr?.previous?.failed?.containerCount
                            )} unique clearance containers`,
                          ]
                        : [
                            `Identified ${sum(
                              tow?.new?.completed?.containerCount,
                              tow?.previous?.completed?.containerCount,
                              tow?.new?.failed?.containerCount,
                              tow?.previous?.failed?.containerCount
                            )} unique towing containers`,
                          ]),
                      ...(isClr
                        ? [
                            `Identified  ${sum(
                              clr?.new?.completed?.vinCount,
                              clr?.previous?.completed?.vinCount,
                              clr?.new?.failed?.vinCount,
                              clr?.previous?.failed?.vinCount
                            )} unique clearance VINs`,
                          ]
                        : [
                            `Identified  ${sum(
                              ship?.new?.completed?.vinCount,
                              ship?.previous?.completed?.vinCount,
                              ship?.new?.failed?.vinCount,
                              ship?.previous?.failed?.vinCount
                            )} unique shipping VINs`,
                          ]),
                      ...(isClr
                        ? []
                        : [
                            `Identified  ${sum(
                              tow?.new?.completed?.vinCount,
                              tow?.previous?.completed?.vinCount,
                              tow?.new?.failed?.vinCount,
                              tow?.previous?.failed?.vinCount
                            )} unique towing VINs`,
                          ]),
                      `Processed ${total} records — ${totalSuccess} succeeded and ${totalFailed} failed.`,
                    ];
                  }}
                />
              </Grid>

              {/* BOT 4 — V-Costing Agent */}
              <Grid
                item
                xs={12}
                md={selectedType === "shipping_towing" ? 6 : 4}
              >
                <SummaryCard
                  img={<img src={LyraIcon} alt="lyra" />}
                  title="V-Costing Agent"
                  color="#FEC700"
                  desc={`${botsSummary.bot4.duration}`}
                  performed={botsSummary.bot4.actionPerformed}
                  points={() => {
                    const safe = (v) => v || 0;
                    const sum = (...v) => v.reduce((a, b) => a + safe(b), 0);

                    const clr = botsSummary?.bot4?.clearance || {};
                    const ship = botsSummary?.bot4?.shipping || {};
                    const tow = botsSummary?.bot4?.towing || {};

                    const isClearance = selectedType === "clearance";

                    // ✅ totals
                    const prevTotal = isClearance
                      ? safe(clr?.previous_total)
                      : sum(ship?.previous_total, tow?.previous_total);

                    const newTotal = isClearance
                      ? safe(clr?.new_total)
                      : sum(ship?.new_total, tow?.new_total);

                    const total = safe(prevTotal + newTotal);

                    // ✅ success
                    const prevSuccess = isClearance
                      ? safe(clr?.previous_success)
                      : sum(ship?.previous_success, tow?.previous_success);

                    const newSuccess = isClearance
                      ? safe(clr?.new_success)
                      : sum(ship?.new_success, tow?.new_success);

                    const totalSuccess = safe(prevSuccess + newSuccess);

                    // ✅ failed
                    const prevFailed = isClearance
                      ? safe(clr?.previous_failed)
                      : sum(ship?.previous_failed, tow?.previous_failed);

                    const newFailed = isClearance
                      ? safe(clr?.new_failed)
                      : sum(ship?.new_failed, tow?.new_failed);

                    const totalFailed = safe(prevFailed + newFailed);

                    // ✅ Lines (protected)
                    const towLine = `Processed Towing: ${sum(
                      tow?.new_total,
                      tow?.previous_total
                    )} total — ${sum(
                      tow?.new_success,
                      tow?.previous_success
                    )} succeeded and ${sum(
                      tow?.new_failed,
                      tow?.previous_failed
                    )} failed`;

                    const shipLine = `Processed Shipping: ${sum(
                      ship?.new_total,
                      ship?.previous_total
                    )} total — ${sum(
                      ship?.new_success,
                      ship?.previous_success
                    )} succeeded and ${sum(
                      ship?.new_failed,
                      ship?.previous_failed
                    )} failed`;

                    return [
                      "Update Costings in ERP",
                      "Finalizing Cost Allocations",
                      `Previous: ${prevTotal} total — ${prevSuccess} succeeded and ${prevFailed} failed`,
                      `New: ${newTotal} total — ${newSuccess} succeeded and ${newFailed} failed`,
                      ...(isClearance ? [] : [towLine, shipLine]),
                      `Processed ${total} records — ${totalSuccess} succeeded and ${totalFailed} failed.`,
                    ];
                  }}
                />
              </Grid>

              {/* BOT 5 — Vega ( Storage & Late Fee Agent ) */}
              {selectedType === "shipping_towing" && (
                <Grid item xs={12} md={6}>
                  <SummaryCard
                    img={<img src={VegaIcon} alt="vega" />} // 🖼️ add Vega.svg/png
                    title="Storage & Late Fee Agent"
                    color="#9C27B0"
                    desc={`${botsSummary.bot5.duration}`}
                    performed={botsSummary.bot5.actionPerformed}
                    points={[
                      `Processed new ${
                        botsSummary.bot5.stats?.new_total || 0
                      } records`,
                      `${
                        botsSummary.bot5.stats?.new_success || 0
                      } new records successful updates`,
                      `${
                        botsSummary.bot5.stats?.new_failed || 0
                      } new records failed`,
                      `Processed previous ${
                        botsSummary.bot5.stats?.previous_total || 0
                      } records`,
                      `${
                        botsSummary.bot5.stats?.previous_success || 0
                      } previous records successful updates`,
                      `${
                        botsSummary.bot5.stats?.previous_failed || 0
                      } previous records failed`,
                      "Vendor Storage & Late Fee Costing Updates",
                    ]}
                  />
                </Grid>
              )}
            </Grid>

            <Box
              sx={{
                width: "100%", // ✅ span full width
                borderBottom: "2px solid #FFFFFF", // ✅ make it a bit stronger
                opacity: 0.3, // ✅ softer look
                mt: 5,
                mb: 10,
              }}
            />

            {/* === Table Section === */}
            <CommonTable
              // title="Clearance Data"
              columns={columns}
              rows={data}
              pagination={pagination}
              loading={loading}
              onPageChange={handlePageChange}
            />
          </Box>
        </>
      )}
    </>
  );
};

export default AiAgent;

const SummaryCard = ({ title, points, img, desc, color, performed }) => (
  <Card
    sx={{
      background: "none",
      borderRadius: 3,
      p: 2,
      color: "white",
      minHeight: "580px",
      border: `1px solid ${color}`,
    }}
  >
    <CardContent>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
        {img}
        <Box sx={{ textAlign: "start" }}>
          <Typography sx={{ fontWeight: "bold", fontSize: "22px" }}>
            {title}
          </Typography>
          <Typography sx={{ fontWeight: 400, fontSize: "14px", mb: 1 }}>
            Job Completion: <strong>{desc}</strong>
          </Typography>
        </Box>
      </Box>

      {(typeof points === "function" ? points() : points)?.map((p, i) => {
        const txt = String(p).toLowerCase();

        // 🎯 Color rules
        const isPrev = txt.startsWith("previous:");
        const isNew = txt.startsWith("new:");
        const isTow = txt.startsWith("processed towing:");
        const isShip = txt.startsWith("processed shipping:");

        return (
          <Box key={i} sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <CheckCircleIcon
              sx={{
                color: performed ? "#5BBC0F" : "#888",
                fontSize: 18,
              }}
            />

            <Typography sx={{ fontSize: "18px", textAlign: "start" }}>
              {String(p)
                .split(/(\d+)/)
                .map((part, idx) => {
                  if (!/^\d+$/.test(part)) return <span key={idx}>{part}</span>;

                  // ✅ Apply correct color
                  let color = "#5BBC0F"; // default green

                  if (isPrev || isNew) color = "#FFF500"; // yellow
                  else if (isTow || isShip) color = "#00E5FF"; // aqua pop

                  return (
                    <span
                      key={idx}
                      style={{
                        color,
                        fontWeight: "bold",
                      }}
                    >
                      {part}
                    </span>
                  );
                })}
            </Typography>
          </Box>
        );
      })}
    </CardContent>
  </Card>
);
